<template>
    <div class="CourseLive_wrap">
        <div class="CourseLive_header">
            <div class="CourseLive_header__secssion">
                <div class="logo-m">
                    <img src="~@/assets/images/LOGO_width.png"/>
                </div>
                <div class="logo">
                    <img src="~@/assets/images/logo_white.png"/>
                </div>
            </div>
            <Headertitle :isListPage="false" :isPlayPage="false" :isexitPage="false"/>
        </div>
        <div class="CourseLive_video_contents_wrap">
            <div class="CourseLive_video_contents">
            <div class="CourseLive_video_box">
                <div class="CourseLive_video_box__video">
                    <iframe 
                        scrolling="no"
                        ref="iframe"
                        :src="EMBEDIEDURL"
                        frameborder="0"
                        allowfullscreen
                        @load="temp"
                        @playing="resizeVideo">
                    </iframe>
                </div>
            </div>
            <div class="CourseLive_video_menu">
                <div class="CourseLive_video_menu__icon_wrap">
                    
                    <!-- <v-btn :href="programSrc" target="_blank" class="CourseLive_video_menu__icon" larg elevation="0" outlined>
                        <v-icon class="mdi mdi-table" color="#3656C9" large/>
                        <span>프로그램</span>
                    </v-btn> -->
                    <v-btn @click="refreshIframe" class="CourseLive_video_menu__icon" larg elevation="0" outlined>
                        <v-icon class="mdi mdi-refresh" large/>
                        <span>새로고침</span>
                    </v-btn>

                    <v-btn @click="downloadPdf" class="CourseLive_video_menu__icon" larg elevation="0" outlined>
                        <v-icon class="mdi mdi-table" large/>
                        <span>프로그램</span>
                    </v-btn>

                    <v-btn @click="downloadEbook" class="CourseLive_video_menu__icon" larg elevation="0" outlined>
                        <v-icon class="mdi mdi-folder-zip-outline" large/>
                        <span>초록집</span>
                    </v-btn>
                    <v-btn @click.stop="openQna" class="CourseLive_video_menu__icon" large elevation="0" outlined>
                            <v-icon class="mdi mdi-tooltip-question-outline" large />
                            <span>질문</span>
                    </v-btn>
                    <v-btn :href="quizSrc" target="_blank" class="CourseLive_video_menu__icon" large elevation="0" outlined>
                        <v-icon class="mdi mdi-bell-ring-outline" large/>
                        <span>퀴즈</span>
                    </v-btn>
                    <v-btn @click="exitBtn" class="CourseLive_video_menu__icon" large elevation="0" outlined>
                        <v-icon class="mdi mdi-exit-to-app" large/>
                        <span>나가기</span>
                    </v-btn>
                </div>
            </div>
        </div>
        </div>
        
        
        <!--질문하기 Dialog-->
        <MessageDialog :load="load" v-model="opendialog" :options="options" :sessions="sessions" :postMsg="postMsg"/>
        <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />
    </div>

    
</template>

<script>
import MessageDialog from '@/components/app/user/MessageDialog.vue';
import AppSnackbar from '@/components/app/AppSnackbar.vue';
import { mapActions } from 'vuex';
import UserApi from '@/api/user/UserApi';
// import PlayerApi from '@/api/player/PlayerApi';
import Headertitle from '@/components/app/user/Headertitle.vue';

export default {
    data () {
        return {
            opendialog: false,
            options: [], 
            selectedOption: null, 
            content: null,
            speaker_id: null,
            snackbarText: null,
            snackbar: false,
            snackbarError: false,
            HLS: null,
            // programSrc: null,
            load: false,
            currentTime: 0,
            updateTimeInterval: null,
            quizSrc: null,
            isReloading: false,
            isUIClosed: false,
            tmptest: null,
        }
    },
    components : {
        MessageDialog,
        AppSnackbar,
        Headertitle,
    },
    created(){
        this.userCheck();
        this.HLS = 'https://j-partners.dnstrip.net/jlive/live/playlist.m3u8';
        this.quizSrc = 'https://forms.gle/58HSemgev1B9CKNW9';
    },
    computed: {
        EMBEDIEDURL() {
            return `${window.location.protocol}//${window.location.host}/player?` + this.HLS;
        },
        sessions(){
            if(this.load){
                return this.options.map(e => e.session);
                // return this.sessionList;
            }
            return [];
        },
        seminarsData(){
            return this.options.map(e => e.seminars).flat().filter(e => e.session_id !== null);
            // this.options.map(e => e.seminars).flat();
        },
        currentSeminar() {
            let calTime = 0;

            for(let seminar of this.seminarsData){
            // for(let seminar of this.options){
            // this.seminarsData.forEach(seminar => {
                calTime += seminar.duration;
                if(this.currentTime < calTime){
                    // console.log("들어옴?");

                    const data = this.options.find(option => option.id === seminar.session_id);
                    if(data) {
                        seminar.session = data.session;
                    }

                    const tmp = {
                        id: seminar.session_id,
                        session: seminar.session,
                        seminar_name: seminar.seminar_name,
                        duration: seminar.duration,
                        speakers: seminar.speakers,
                    }
                    // console.log("tmp => ", tmp);

                    return tmp;
                }
            // // });
            // }
            
            //  for(let session of this.options){
            //     for(let seminar of session.seminars){
            //         calTime += seminar.duration;
            //         // const startTime = this.convertToSeconds(seminar.startTime);
            //         // // const startTime = Math.floor(Date.now() / 1000);
            //         // const endTime = startTime + seminar.duration;

            //         // console.log("startTime : " , startTime)
            //         // console.log("endTime : " , endTime)
            //         if(this.currentTime < calTime){
            //         // if(this.currentTime <= endTime){
            //         // if(this.currentTime >= startTime && this.currentTime <= endTime){
            //             console.log("들어옴?")
            //             const tmp = {
            //                 id: session.id,
            //                 session: session.session,
            //                 seminar_name: seminar.seminar_name,
            //                 duration: seminar.duration,
            //                 speakers: seminar.speakers,
            //             }
            //             console.log("tmp => ", tmp);

            //             return tmp;
            //         }

            // // for(let session of this.options){
            // //     for(let seminar of session.seminars){
            // //         const startTime = this.convertToSeconds(seminar.startTime);
            // //         const endTime = this.convertToSeconds(seminar.endTime);

           
            // //         // console.log("startTime => ", startTime);
            // //         // console.log("endTime => ", endTime);

            // // //         if(this.currentTime >= startTime && this.currentTime <= endTime){
            // //             console.log("*확인*");

            // //             const tmp = {
            // //                 id: session.id,
            // //                 session: session.session,
            // //                 seminar_name: seminar.seminar_name,
            // //                 duration: seminar.duration,
            // //                 speakers: seminar.speakers,
            // //             }
            // //             console.log("tmp => ", tmp);

            // //             return tmp;
            // //         }
                // }
            }
            return null;
        },
        // currentTime: {
        //     get() {
        //         return this.updateTimeInterval;
        //     },
        //     set(value) {
        //         return value;
        //     },
        // }
    },
    mounted() {
        this.fetchOptions();
        // console.log("확인")
        // if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
        //     this.isReloading = true;

        // } else {
        //     this.isReloading = false;
        // }

        if (sessionStorage.getItem("isReloading") === "true") {
            this.isReloading = true;
            sessionStorage.removeItem("isReloading");
        } else {
            this.isReloading = false;
        }

        // window.addEventListener("beforeunload", (event) => {
        //     sessionStorage.setItem("isReloading", "true");
        // });

        // window.addEventListener('beforeunload', () => {
        //     // sessionStorage.setItem("isReloading", "true");
        //     this.exitBtn()
        // });

        // window.addEventListener('beforeunload', this.leave);
        // window.addEventListener('unload', this.handleUnload);

        // const time = 5 * 60 * 1000; // 5분
        // this.pollingInterval = setInterval(() => {
        //     // this.isUIClosed = this.checkIfUIClosed();
        //     // this.isUIClosed = true;

        //     // console.log(this.isUIClosed)
        //     this.sendUIStatus();
        // }, time);  

        //  window.addEventListener('beforeunload', (e) => {
        //     if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
        //         return; 
        //     }
        //     this.exitBtn();
        //     e.preventDefault();
        //     e.returnValue = '';
        // });


    },
    destroyed() {
        window.removeEventListener('beforeunload', this.leave);
    },
    beforeDestroy() {
        clearInterval(this.pollingInterval);
        if (this.updateTimeInterval) {
            clearInterval(this.updateTimeInterval);
        }
    },
    // watch: {
    //     currentTime: 'updateCurrentTime', 
    //     currentSeminar: 'currentTime',
    // },
    methods: {
        ...mapActions('user', ['logout', 'userCheck']),
        exitBtn(){
            this.logout()
                .then(() => {
                    this.$router.push({ path: '/' });
                })
                .catch(error => {
                    console.error('Logout error:', error);
                });
        },
        refreshIframe(){
            this.userCheck();
            const originalURL = this.EMBEDIEDURL;
            this.$refs.iframe.src = '';
            this.$nextTick(() => {
                this.$refs.iframe.src = originalURL;
                const video =  this.$refs.iframe.contentWindow.document.querySelector('video');
                video.autoplay = true;
                video.play();
            });
        },
        // checkIfUIClosed() {
        //     return document.hidden;  
        // },
        // async sendUIStatus() {
        //     try {
        //         // const now = new Date();
        //         // const now = Date.now();
        //         const now = "check";
        //         // const time =  now.toLocaleTimeString();
        //         await UserApi.checkStatus(now);
        //     } catch (error) {
        //         console.error('Failed to send UI status', error);
        //     }
        // },
        leave(){
            // if (this.isReloading || sessionStorage.getItem("isReloading") === "true") {
            // // if (sessionStorage.getItem("isReloading") === "true" || sessionStorage.getItem("isReloading") === true) {
            //     return;
            // } else {
            //     this.exitBtn();
            //     event.preventDefault();
            //     event.returnValue = false;
            // }
            this.exitBtn();
            // if(sessionStorage.getItem("isReloading")){
            //     event.preventDefault();
            //     event.returnValue = false;
            // } else {
            //     event.preventDefault();
            //     event.returnValue = false;
            //     this.exitBtn();
            // }
        },
        // isMobile(){
        //     const info = /Mobi|Android/i.test(navigator.userAgent);
        //     console.log("isMobile => ", info);  // false (pc), true (mobile)
        // },
        handleUnload(){
            sessionStorage.removeItem("isReloading")
        },
        async openQna(){
            await this.fetchOptions();
            this.opendialog = true;
        },
        async fetchOptions() {
            try {
                const response = await UserApi.qnaSessionListApi();
                // console.log("response => ", response)
                this.load = true;
                this.options = response.map(e => e);
                // this.sessions = this.options.map(e => e.session);
                // console.log("this.options => ", this.options);
                // console.log("list => ", this.options)
            } catch (error) {
                console.error("Error fetching options:", error);
            }
        },
        async postMsg(selValue, content){
            try {
                this.content = content;
                this.speaker_id = selValue;
                const qnaData = {
                    speaker_id: this.speaker_id,
                    content: this.content
                }
                const response = await UserApi.qnaApi(qnaData);
                // console.log("postMsg res => ", response);
                this.opendialog = false;
                if(response.status === '1' || response.status === 1){
                    setTimeout(() => {
                        this.snackbar = true;
                        this.snackbarText = response.message;
                        this.snackbarError = false;
                        setTimeout(() => {
                            this.snackbar = false;
                        }, 2000);
                    }, 1000);
                } else {
                    setTimeout(() => {
                        this.snackbar = true;
                        this.snackbarText = response.message;
                        this.snackbarError = true;
                        setTimeout(() => {
                            this.snackbar = false;
                            this.snackbarError = false;
                        }, 2000);
                    }, 1000);
                }
            } catch (error) {
                console.error("Error fetching options:", error);
            } 
        },
        // temp() {
        //     const iframe = this.$refs.iframe;
        //     const video = iframe.contentWindow.document.querySelector('video');
        //     if (!video) return;

        //     // const container = iframe.parentElement;
        //     // // const containerWidth = container.offsetWidth;
        //     // const videoWidth = video.videoWidth;
        //     // const videoHeight = video.videoHeight;
        //     // const aspectRatio = videoWidth / videoHeight;

        //     // if (aspectRatio < 1) {
        //     //     container.style.paddingBottom = `${(videoHeight / videoWidth) * 100}%`;
        //     // } else {
        //     //     container.style.paddingBottom = '56.25%';
        //     // }

        //     // video.autoplay = true;
        //     // video.play();

        //     // this.updateTimeInterval = setInterval(() => {
        //     //     const newTime = video.currentTime;
                
        //     //     if (this.currentTime !== newTime) {
        //     //         this.currentTime = newTime;
        //     //         // console.log("Updated currentTime: ", this.currentTime);
        //     //     }
        //     //     // const currentVideoTime = this.convertTimeToCurrentTime();
                
        //     //     // if (currentVideoTime !== this.currentTime) {
        //     //     //     this.currentTime = currentVideoTime;
        //     //     //     // console.log("Updated currentTime: ", this.currentTime);
        //     //     // }
        //     // }, 1000); 
        // },
        // convertTimeToCurrentTime() {
        //     if (!this.startTime) return 0; // 시작 시간이 설정되지 않은 경우 기본값 0

        //     const now = new Date();
        //     const elapsedTimeInSeconds = Math.floor((now - this.startTime) / 1000);

        //     // 시작 시간 전에는 0으로 설정
        //     return elapsedTimeInSeconds > 0 ? elapsedTimeInSeconds : 0;
        // },
        // resizeVideo() {
        //     const iframe = this.$refs.iframe;
        //     const video = iframe.contentWindow.document.querySelector('video');
        //     // const iframeDocument = iframe.contentWindow.document;
        //     if (!video) return;

        //     const container = iframe.parentElement;
        //     // const containerWidth = container.offsetWidth;
        //     const videoWidth = video.videoWidth;
        //     const videoHeight = video.videoHeight;
        //     const aspectRatio = videoWidth / videoHeight;

        //     if (aspectRatio < 1) {
        //         container.style.paddingBottom = `${(videoHeight / videoWidth) * 100}%`;
        //     } else {
        //         container.style.paddingBottom = '56.25%';
        //     }

        //     video.autoplay = true;
        //     video.play();

        //     // const seminarStartTime = "09:00:00";
        //     // const seminarStartInSeconds = this.convertToSeconds(seminarStartTime);

        //     // this.updateTimeInterval = setInterval(() => {
        //     //     const newTime = video.currentTime;
                
        //     //     if (this.currentTime !== newTime) {
        //     //         this.currentTime = newTime;
        //     //         // this.currentTime = (Date.now() / 1000) - seminarStartInSeconds; 
        //     //         // console.log("Updated currentTime: ", this.currentTime);
        //     //     }
        //     //     // const currentVideoTime = this.convertTimeToCurrentTime();
                
        //     //     // if (currentVideoTime !== this.currentTime) {
        //     //     //     this.currentTime = currentVideoTime;
        //     //     //     // console.log("Updated currentTime: ", this.currentTime);
        //     //     // }
        //     // }, 1000); 

        // },
        async temp() {
            // await PlayerApi.playStart();
            // console.log("temp 1")
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            if (!video) return;
        },
        resizeVideo() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            // const iframeDocument = iframe.contentWindow.document;
            if (!video) return;

            const container = iframe.parentElement;
            // const containerWidth = container.offsetWidth;
            const videoWidth = video.videoWidth;
            const videoHeight = video.videoHeight;
            const aspectRatio = videoWidth / videoHeight;

            if (aspectRatio < 1) {
                container.style.paddingBottom = `${(videoHeight / videoWidth) * 100}%`;
            } else {
                container.style.paddingBottom = '56.25%';
            }

            video.autoplay = true;
            video.play();

        },
        convertToSeconds(time){
            const [hours, minutes, seconds] = time.split(":").map(Number);
            return hours * 3600 + minutes * 60 + seconds;
        },
        updateCurrentTime(){
            // console.log("updateCurrentTime : " , this.currentTime);
            // console.log("currentSeminar => ", this.currentSeminar)
        },
        downloadPdf() {
            const link = document.createElement('a');
            //link.href = '/pdf/Atherosclerosis to Zero_program.pdf';  // public 폴더에 있는 파일 경로
            //link.download = '제8회 A to Z 연수강좌(Atherosclerosis to Zero)프로그램.pdf'; // 다운로드될 파일 이름


            link.href = '/pdf/programlist.pdf';
            link.download = '제14회AtoZ연수강좌_프로그램.pdf';
            link.click();
        },
        downloadEbook(){
             const link = document.createElement('a');
             link.href = '/pdf/Abstract_manuscript.pdf';
             link.download = '14 ATOZ 초록집.pdf';
             link.click();
        }
    }
}
</script>

<style scoped>

</style>
